import { Backdrop, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';

import { ComponentSpinnerRingStyles, ComponentSpinnerStyles } from './componentSpinner.styles.ts';

type Props = {
  caption?: string;
  isVisible: boolean;
};

export const ComponentSpinner: React.FC<Props> = props => {
  const { caption, isVisible } = props;

  if (!isVisible) {
    return null;
  }

  return (
    <Backdrop open sx={ComponentSpinnerStyles}>
      <Container>
        <Box sx={ComponentSpinnerRingStyles}>
          <Box>
            <CircularProgress size={48} sx={{ color: themeColors.accentColor }} />
          </Box>
          {caption && <Box sx={{ color: themeColors.white }}>{caption}</Box>}
        </Box>
      </Container>
    </Backdrop>
  );
};
